export default "__VITE_ASSET__CMdyz2bJ__"